export class NumbersService {
    amount2DecimalTypePattern = (() => {
        let regexp = new RegExp('^[\-]?[0-9]{1,11}\\.[0-9]{2}$');
        return {
            test: (value: any) => {
                let formattedValue = this.formatDecimal(value, 2);
                return regexp.test(formattedValue);
            }
        };
    })();

    amount8DecimalTypePattern = (() => {
        let regexp = new RegExp('^[\-]?[0-9]{1,11}\\.[0-9]{2,8}$');
        return {
            test: (value: any) => {
                let formattedValue = this.formatDecimal(value, 8);
                return regexp.test(formattedValue);
            }
        };
    })();

    quantitaTypePattern = (() => {
        let regexp = new RegExp('^[0-9]{1,12}\\.[0-9]{2,8}$');
        return {
            test: (value: any) => {
                let formattedValue = this.formatDecimal(value, 8);
                return regexp.test(formattedValue);
            }
        };
    })();

    rateTypePattern = (() => {
        let regexp = new RegExp('^[0-9]{1,3}\\.[0-9]{2}$');
        return {
            test: (value: any) => {
                let formattedValue = this.formatDecimal(value, 2);
                try {
                    if (parseFloat(formattedValue) > 100) {
                        return false;
                    }
                } catch (ex) { /* */ }

                return regexp.test(formattedValue);
            }
        };
    })();

    pesoTypePattern = (() => {
        let regexp = new RegExp('^[0-9]{1,4}\\.[0-9]{1,2}$');
        return {
            test: (value: any) => {
                let formattedValue = this.formatDecimal(value, 2);
                return regexp.test(formattedValue);
            }
        };
    })();

    formatDecimal(input: any, decimals: any): any {
        if (input !== undefined) {
            if (typeof input === 'string') {
                input = input.replace(',', '.');
            }
            let exponent = Math.pow(10, decimals);
            let int: number = Math.round(input * exponent) / exponent;
            let res: string = int.toFixed(decimals);
            // keep only 2 decimal if are diff then 0
            if (decimals > 2 && res.indexOf('.') > -1) {
                let splits = res.split('.');
                if (splits.length === 2) {
                    let decimalsPart = splits[1];
                    for (let i = splits[1].length - 1; i >= 2; i--) {
                        if (splits[1][i] === '0') {
                            decimalsPart = decimalsPart.substring(0, decimalsPart.length - 1);
                        } else {
                            break;
                        }
                    }
                    res = splits[0] + '.' + decimalsPart;
                }
            }
            return isNaN(res as any) ? '0.00' : res;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/ui/numbers.service.ts